import { api } from './client';

/** Mirrors PayrollConfigDto (Api/UseCases/Payroll/ManagePayrollConfig). */
export interface WageRateDto {
  rateTypeCode: number;
  rateTypeName: string;
  value: string;
  validFrom: string;
}

export interface WageAccountDto {
  accountType: number;
  accountTypeName: string;
  accountNumber: number | null;
}

export interface PayrollConfigDto {
  rates: WageRateDto[];
  accounts: WageAccountDto[];
}

export const payrollConfigApi = {
  get: () => api.get<PayrollConfigDto>('/payroll/config'),

  saveRates: (updates: { rateTypeCode: number; value: string }[]) =>
    api.put<void>('/payroll/config/rates', { updates }),

  saveAccounts: (updates: { accountType: number; accountNumber: number }[]) =>
    api.put<void>('/payroll/config/accounts', { updates }),
};
